/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{multiplyOpacityToUnitRGBA as o}from"../../../../core/colorUtils.js";import{f as r}from"../../../../chunks/vec4f64.js";const c=r(0,0,0,.04);function t({accentColor:r}){return o(r,.5)}function n({accentColor:r}){return o(r,.7)}export{t as getGridColor,n as getOutlineColor,c as planeColor};
